import React, { ReactNode } from 'react';

import { HeaderRenderer } from './HeaderRenderer';
import { ParagraphRenderer } from './ParagraphRenderer';
import { ListRenderer } from './ListRenderer';
import { DelimiterRenderer } from './DelimiterRenderer';
import { ImageRenderer } from './ImageRenderer';
import { QuoteRenderer } from './QuoteRenderer';
import { LinkRenderer } from './LinkRenderer';
import { ContentSize, RenderData, TitleDescriptionObject } from './types';


export * from './types';

const componentMap = {
    header: HeaderRenderer,
    paragraph: ParagraphRenderer,
    list: ListRenderer,
    delimiter: DelimiterRenderer,
    image: ImageRenderer,
    quote: QuoteRenderer,
    linkTool: LinkRenderer,
};

export const renderContent = (data: RenderData, size: ContentSize = 'desktop'): ReactNode[] =>
    data.blocks.map((block, index) => {
        const Component = componentMap[block.type];
        return Component ? <Component key={index} {...block.data} size={size} /> : '';
    });


// Get first header block as a main title,
// get first text block (header or paragraph) as a description
export const getTitleAndDescription = (
    data: RenderData,
): TitleDescriptionObject => {
    const firstHeaderIndex = data.blocks.findIndex(
        elem => elem.type === 'header',
    );
    const textIndex = data.blocks.findIndex(
        (elem, index) =>
            index !== firstHeaderIndex &&
            (elem.type === 'header' || elem.type === 'paragraph'),
    );
    return {
        title:
            firstHeaderIndex !== -1 && data.blocks[firstHeaderIndex]
                ? data.blocks[firstHeaderIndex].data.text
                : '',
        description:
            textIndex !== -1 && data.blocks[textIndex]
                ? data.blocks[textIndex].data.text
                : '',
    };
};
